var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 194,
    viewBox: "0 0 221 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7235 10H10V183.288H56.5828V107.513L93.849 183.288H175.11V141.363V32.6703V10H128.424V32.6703V141.363L60.7235 10Z",
    fill: "#A91212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.11 10H128.424V32.6703V141.363L60.7235 10H10V183.288H56.5828V107.513L93.849 183.288H175.11M175.11 10H210.617V32.6703M175.11 10V32.6703M175.11 32.6703V141.363V183.288M175.11 32.6703H210.617M175.11 183.288H210.617V32.6703",
    stroke: "#150202",
    strokeWidth: 20
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175.007,
    y: 10,
    width: 35.4029,
    height: 22.5668,
    fill: "#150202"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 177.802,
    y: 35.3618,
    width: 30.227,
    height: 145.235,
    fill: "#FFF9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ca95679cf7c7e523ffdfa10f5292297.svg";
export { ForwardRef as ReactComponent };